import React, { useState, useEffect } from 'react'
import { createList } from './templates'
import './style.scss'

const Dropdown = ({ list, callback, defaultValue, name, defaultText }) => {
  const [value, setValue] = useState(defaultValue || { text: '', value: '' })
  const [display, setDisplay] = useState(false)
  const params = { list, setValue, callback, name }

  useEffect(() => {
    if (!value.value && !defaultText) setValue(list[0])
    //if defaultText then show it
    if (defaultText) setValue({ text: `- ${defaultText} -`, value: 'default' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="dropdown" onClick={() => setDisplay(!display)}>
      <div className="trigger">
        {value.value === 'default' ? <div className="default-text">{value.text}</div> : value.text}
        <i className="fas fa-chevron-down"></i>
      </div>
      {display && (
        <>
          <div
            className="shadow"
            onClick={() => {
              setDisplay(false)
            }}
          />
          <div className="list">{createList(params)}</div>
        </>
      )}
    </div>
  )
}
export default Dropdown
